import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'sonner';

const LoginModal = ({ open, onOpenChange, onSuccess, message }) => {
  const { login, t } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) return;
    setLoading(true);
    try {
      await login(email, password);
      toast.success('Ingelogd!');
      onOpenChange(false);
      if (onSuccess) onSuccess();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Inloggen mislukt');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="login-modal">
        <DialogHeader>
          <DialogTitle className="font-heading text-xl text-primary">Inloggen om verder te gaan</DialogTitle>
          <DialogDescription className="text-muted-foreground">
            {message || 'Log in of maak een account aan om deze actie uit te voeren.'}
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4 pt-2">
          <div className="space-y-2">
            <Label htmlFor="modal-email">E-mailadres</Label>
            <Input
              id="modal-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="jouw@email.nl"
              className="h-11"
              required
              data-testid="login-modal-email"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="modal-password">Wachtwoord</Label>
            <Input
              id="modal-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Wachtwoord"
              className="h-11"
              required
              data-testid="login-modal-password"
            />
          </div>
          <Button
            type="submit"
            className="w-full h-11 btn-primary"
            disabled={loading}
            data-testid="login-modal-submit"
          >
            {loading ? 'Even geduld...' : 'Inloggen'}
          </Button>
          <div className="text-center text-sm text-muted-foreground space-y-1">
            <p>Nog geen account? <Link to="/register" onClick={() => onOpenChange(false)} className="text-brand font-medium hover:underline" data-testid="login-modal-register-link">Maak er een aan</Link></p>
            <p><Link to="/wachtwoord-vergeten" onClick={() => onOpenChange(false)} className="text-brand font-medium hover:underline">Wachtwoord vergeten?</Link></p>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default LoginModal;
